function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFtntpClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#86cbb4",
      strokeWidth: 4.2048,
      fill: "#ffff"
    },
    d: "m58.842 36.967a27.352 27.352 0 1 1 -54.704 0 27.352 27.352 0 1 1 54.704 0z",
    transform: "matrix(.78008 0 0 .78008 .26695 -6.2506)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinejoin: "round",
      stroke: "#4c4c4c",
      strokeWidth: 5,
      strokeLinecap: "round",
      fill: "none"
    },
    d: "m24.722 22.363v-15.76"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinejoin: "round",
      stroke: "#4c4c4c",
      strokeWidth: 5,
      strokeLinecap: "round",
      fill: "none"
    },
    d: "m25.65 22.661 10.546 6.0888"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#333333",
      strokeLinecap: "round",
      strokeWidth: 3.0256,
      fill: "#333333"
    },
    d: "m31.491 32.288a2.3393 2.3393 0 1 1 -4.6786 0 2.3393 2.3393 0 1 1 4.6786 0z",
    transform: "matrix(.82628 0 0 .82628 .74475 -4.0928)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtntpClient);
export default __webpack_public_path__ + "static/media/ftntp-client.5df1232cbf50c6ec0162e3709a10c712.svg";
export { ForwardRef as ReactComponent };